import {
    FacebookShareButton,
    HatenaShareButton,
    LineShareButton,
    TwitterShareButton,
    FacebookIcon,
    HatenaIcon,
    LineIcon,
    TwitterIcon,
  } from "react-share";
  import './shareButton.css';
  
  
  const URL = 'https://example.com/';
  const QUOTE = '共有するときのメッセージ';
  
  const ShareButton = (props) => {
    return (
      <div className='share__button grid'>
        <FacebookShareButton url={URL} quote={QUOTE}>
          <FacebookIcon size={24} round />
        </FacebookShareButton>
        <TwitterShareButton url={URL} title={QUOTE}>
          <TwitterIcon size={24} round />
        </TwitterShareButton>
        <LineShareButton url={URL} title={QUOTE} >
          <LineIcon size={24} round />
        </LineShareButton>
        <HatenaShareButton
          url={URL}
          title={QUOTE}
          windowWidth={660}
          windowHeight={460}
        >
          <HatenaIcon size={24} round />
        </HatenaShareButton>
      </div>
    )
  }
  export default ShareButton;